'use client';
import classNames from 'classnames';
import getLocal from 'eco-design-reliance/getLocal';
import gtm from 'eco-design-reliance/gtm';
import { useEffect, useState } from 'react';
import { langTxt } from '../../lang';
import { useScrollDirection } from '../../utils/useScrollDirection';

export default function WidgetsArrowSvgA() {
    const [hideA, setHideA] = useState(false);
    const prefixCls = 'widgets-ArrowSvgA';
    const compCls = classNames(prefixCls, 'GtmModuleData-btn-common', {
        [`widgets-ArrowSvgA-hide`]: hideA,
        [`widgets-ArrowSvgA-open`]: !hideA,
    });
    const { pathname, locale } = getLocal();
    const lang = langTxt[locale as string] || langTxt['us'];
    const { showWidget } = useScrollDirection({ forceHide: hideA });
    const toggleHandle = () => {
        const hideA2 = !hideA;
        setHideA(hideA2);
        if (hideA2) {
            gtm.push({
                __btn_type: 'common',
                __btn_id1: 'widgets-ArrowSvgA-hide',
                __btn_id2: 'ArrowSvgA',
                event: 'uaEvent',
                event_name: 'product_preview_page',
                list_name: 'none',
                buttonName: 'Collapse',
            });
        } else {
            gtm.push({
                __btn_type: 'common',
                __btn_id1: 'widgets-ArrowSvgA-open',
                __btn_id2: 'ArrowSvgA',
                event: 'uaEvent',
                event_name: 'product_preview_page',
                list_name: 'none',
                buttonName: 'Expand',
            });
        }
    };

    useEffect(() => {
        setHideA(!showWidget);
    }, [showWidget]);

    useEffect(() => {
        const handleForceExpand = () => setHideA(false);
        const handleForceCollapse = () => setHideA(true);
        window.addEventListener('widgets-force-expand', handleForceExpand);
        window.addEventListener('widgets-force-collapse', handleForceCollapse);
        return () => {
            window.removeEventListener('widgets-force-expand', handleForceExpand);
            window.removeEventListener('widgets-force-collapse', handleForceCollapse);
        };
    }, []);

    return (
        <div className={compCls} data-btn-id="ArrowSvgA">
            <span className="WidgetsItem-icon WidgetsItem-icon-arrow" onClick={toggleHandle}>
                <span className="WidgetsItem-icon-inner">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" className="widgets-ArrowSvgA-svg">
                        <path
                            d="M7.99414 16.542L14.2593 12.0552L7.99414 7.56787L9.15869 5.94189L16.5591 11.2422C16.8211 11.43 16.9766 11.7328 16.9766 12.0552C16.9765 12.3776 16.8212 12.6804 16.5591 12.8682L9.15869 18.168L7.99414 16.542Z"
                            fill="currentColor"
                        />
                    </svg>
                </span>
            </span>
            <span className={`widgets-ArrowSvgA-msg ${hideA ? 'hide' : 'block'}`}>
                <span className="widgets-ArrowSvgA-msg-line1">
                    <span className="tips">{lang['collapse']}</span>
                </span>
                <span className="rect"></span>
            </span>
        </div>
    );
}
